export const DEFAULT_QUERY_LIMIT = 20;

export const DEFAULT_QUERY_PARAMS = {
  _start: 0,
  _limit: DEFAULT_QUERY_LIMIT,
};

export const MAX_LIMIT = -1;
